export const removeFalsyFromQueryParams = (queryString: string): string => {
  const params = new URLSearchParams(queryString);
  [...params.entries()].forEach(([key, value]) => {
    if (!value) {
      params.delete(key);
    }
  });
  const cleanedParams = String(params);
  return cleanedParams;
};

export const fixedEncodeURI = (uri: string) => {
  return encodeURI(uri).replace(/%5B/g, '[').replace(/%5D/g, ']');
};

export const validURL = (url: string) => {
  try {
    return Boolean(new URL(url));
  } catch (_e) {
    return false;
  }
};

export const convertToRelativeUrl = (url: string) => url?.replace('https://www.benzinga.com/', '/');

export const getYoutubeVideoIdFromUrl = (url: string) => {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

export const appendQueryParams = (url: string, params: Record<string, string | undefined>) => {
  const urlObj = new URL(url);
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      urlObj.searchParams.set(key, value);
    }
  });
  return urlObj.toString();
};

export function parseUtmSourceFromUrl(url: string | undefined): string | null {
  if (!url) return null;
  const queryStart = url.indexOf('?');
  if (queryStart === -1) return null;
  const params = new URLSearchParams(url.slice(queryStart));
  return params.get('utm_source');
}

export function queryToParams(query: Record<string, string | string[] | undefined>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(query).map(([key, value]) => [key, Array.isArray(value) ? (value[0] ?? '') : (value ?? '')]),
  );
}

export function getUtmSource(
  url: string | undefined,
  query?: Record<string, string | string[] | undefined>,
): string | null {
  const fromQuery = query?.utm_source;
  const utmSourceFromQuery = typeof fromQuery === 'string' ? fromQuery : null;
  return utmSourceFromQuery ?? parseUtmSourceFromUrl(url);
}
